import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import * as Sentry from "@sentry/react";
import { initSentry } from './utils/sentry';

// ✅ Inicializar Sentry PRIMERO
initSentry();

// Estilos Globales
import './index.css'

// Componente Principal
import App from './App.jsx'

// 🔥 Registrar Service Worker
registerSW({
  immediate: true,
  onRegistered(registration) {
    console.log('✅ Service Worker registrado:', registration)
  },
  onRegisterError(error) {
    console.error('❌ Error registrando Service Worker:', error)
  }
})

// ✅ Envolver App con Sentry ErrorBoundary y Profiler
const SentryApp = Sentry.withProfiler(App);

// ✅ CORREGIDO: Providers SOLO en App.jsx, aquí solo ErrorBoundary
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-gray-800 border border-red-500/50 rounded-xl p-6">
            <h2 className="text-xl font-bold text-red-400 mb-2">
              ¡Ups! Algo salió mal 😔
            </h2>
            <p className="text-gray-300 text-sm mb-4">
              El error fue reportado automáticamente. Podés intentar recargar la página.
            </p>
            <details className="mb-4">
              <summary className="text-sm text-gray-400 cursor-pointer hover:text-gray-300">
                Ver detalles técnicos
              </summary>
              <pre className="text-xs text-red-400 mt-2 bg-gray-900 p-2 rounded overflow-auto max-h-40">
                {error.toString()}
              </pre>
            </details>
            <div className="flex gap-3">
              <button
                onClick={resetError}
                className="flex-1 bg-gray-700 hover:bg-gray-600 text-white py-2 px-4 rounded-lg transition active:scale-95"
              >
                Intentar de nuevo
              </button>
              <button
                onClick={() => window.location.href = '/'}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition active:scale-95"
              >
                Ir al inicio
              </button>
            </div>
          </div>
        </div>
      )}
      showDialog
    >
      <SentryApp />
    </Sentry.ErrorBoundary>
  </StrictMode>
)